import { createUseStyles } from '@glu/theming';

const styles = {
  highlight: {
    '& span': {
      fontWeight: 700
    }
  }
};

export default createUseStyles(styles);
